import { render, staticRenderFns } from "./MensagemRetorno.vue?vue&type=template&id=a223a5b8&scoped=true"
import script from "./MensagemRetorno.vue?vue&type=script&lang=js"
export * from "./MensagemRetorno.vue?vue&type=script&lang=js"
import style0 from "./MensagemRetorno.vue?vue&type=style&index=0&id=a223a5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a223a5b8",
  null
  
)

export default component.exports